import { type SaveMigration, updateEnvelopeVersion } from "@e308/core";
import { CONTENT_DIGEST, CONTENT_VERSION } from "./build-identity.js";

export const WAVE_TIMING_MIGRATION: SaveMigration = {
  id: "kilnfront-configurable-wave-timing-1",
  fromVersion: 1,
  toVersion: 2,
  migrate(source) {
    if (
      source.content.version !== "kilnfront-ruleset-2" ||
      source.content.digest !==
        "sha256:3e6db5bc2f7238ebc552bb9d3f4b559c689d34a5e99c5e4444dee734f9072294"
    )
      throw new TypeError("This save requires its original compatible Kilnfront build");
    // Missing per-front timers intentionally retain the original five-second
    // schedule. No resources, orders, elapsed time, or replay entries are changed.
    return updateEnvelopeVersion(source, {
      stateSchemaVersion: 2,
      contentVersion: CONTENT_VERSION,
      contentDigest: "sha256:cdbddfa151b1d4483160dda20011987edfce22cf21fc529148d7f584723baa34",
    });
  },
};

export const ARMY_ALLOCATION_MIGRATION: SaveMigration = {
  id: "kilnfront-army-allocation-1",
  fromVersion: 2,
  toVersion: 3,
  migrate(source) {
    if (
      source.content.version !== CONTENT_VERSION ||
      source.content.digest !==
        "sha256:cdbddfa151b1d4483160dda20011987edfce22cf21fc529148d7f584723baa34"
    )
      throw new TypeError("This save requires its original compatible Kilnfront build");
    // Existing orders remain untouched until an ordinary Army allocation input.
    return updateEnvelopeVersion(source, {
      stateSchemaVersion: 3,
      contentVersion: CONTENT_VERSION,
      contentDigest: CONTENT_DIGEST,
    });
  },
};
